<!--GeneratorFlag:[NoChange]-->
<template>
	<router-view :key="$route.path" />
</template>